import * as APPCONFIG from "../../src/config/app-config";
import auth from "./AuthAPI.js";
import Http from "./Http.js";

export const transactionFilter = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/transactions/filter`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const createScheduledTransactions = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/scheduled-transactions`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export function generateTransactionExcelReport(form) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    responseType: "blob",
    url: `${APPCONFIG.API_URL}auth/transactions/export-pdf`,
    data: form,
  });
}
